import classNames from 'classnames';
import React, { FC } from 'react'

type CloseButtonProps = {
  onClick: () => void;
  buttonLabel?: string;
  withWhiteBg?: boolean;
}

export const CloseButton: FC<CloseButtonProps> = ({
  onClick,
  buttonLabel = "Lukk",
  withWhiteBg = false
}) => {
  return (
    <button
      className={classNames("btn btn-close react-modal__close d-block ms-auto me-n1", {
        'bg-white': withWhiteBg
      })}
      onClick={onClick}
    >
      {buttonLabel}
      <span className="visually-hidden">
        timebestilling (x)
      </span>
    </button>
  )
};
